import { render, staticRenderFns } from "./StatusesBlock.vue?vue&type=template&id=47132ec8&scoped=true"
import script from "./StatusesBlock.vue?vue&type=script&lang=js"
export * from "./StatusesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47132ec8",
  null
  
)

export default component.exports